import { AfterViewInit, Directive, Host, OnDestroy, Self } from '@angular/core';
import { NgControl } from '@angular/forms';
import { NgxIntlTelInputComponent } from 'ngx-intl-tel-input';
import { untilDestroyed } from '$core/operators/until-destroyed.operator';
import { debounceTime } from 'rxjs/operators';

@Directive({
  selector: '[phonePrefix]',
})
export class PhonePrefixDirective implements AfterViewInit, OnDestroy {
  private priveosIso2: string;
  constructor(
    @Self() private ngxIntlTelInput: NgxIntlTelInputComponent,
    private control: NgControl
  ) {}

  public ngOnDestroy(): void {}

  public ngAfterViewInit(): void {
    this.priveosIso2 = this.ngxIntlTelInput.selectedCountry.iso2.toUpperCase();
    if (!this.control.value) {
      this.control.reset(
        '+' + this.ngxIntlTelInput.selectedCountry.dialCode + ' '
      );
    }

    this.control.valueChanges
      .pipe(untilDestroyed(this), debounceTime(300))
      .subscribe((res) => {
        if (typeof res === 'string') {
          this.priveosIso2 =
            this.ngxIntlTelInput.selectedCountry.iso2.toUpperCase();
          return;
        }
        if (res) {
          try {
            if (this.priveosIso2 !== res.countryCode.toUpperCase()) {
              this.control.reset(
                '+' + this.ngxIntlTelInput.selectedCountry.dialCode + ' '
              );
            }
          } catch (error) {
            console.log(error);
          }
        }

        this.priveosIso2 =
          this.ngxIntlTelInput.selectedCountry.iso2.toUpperCase();
      });
  }
}
